import { render, staticRenderFns } from "./PolizasAdministracionResponse.vue?vue&type=template&id=e0c868e0&scoped=true&"
import script from "./PolizasAdministracionResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasAdministracionResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c868e0",
  null
  
)

export default component.exports